import { existsSync } from "fs";
import { resolve } from "path";
var sharpWarned = false;
async function getSharp() {
  try {
    var sharpModule = await import("sharp");
    return sharpModule.default;
  } catch (e) {
    if (!sharpWarned) {
      sharpWarned = true;
      console.warn(`
[one] To use getImageData, install sharp:

  npm install sharp
`);
    }
    return null;
  }
}
async function processImageMeta(filePath) {
  var sharp = await getSharp();
  if (!sharp) {
    return null;
  }
  try {
    var image = sharp(filePath);
    var metadata = await image.metadata();
    var { width = 0, height = 0 } = metadata;
    var blurBuffer = await image.resize(10).blur(1).jpeg({
      quality: 40
    }).toBuffer();
    var blurDataURL = `data:image/jpeg;base64,${blurBuffer.toString("base64")}`;
    return {
      width,
      height,
      blurDataURL
    };
  } catch (e) {
    console.warn(`[one] processImageMeta: Failed to process ${filePath}:`, e);
    return null;
  }
}
async function getImageData(filePath) {
  var resolvedPath;
  var src;
  if (filePath.startsWith("/")) {
    resolvedPath = resolve("./public", filePath.slice(1));
    src = filePath;
  } else {
    resolvedPath = resolve(filePath);
    src = filePath.replace(/^\.\.?\//, "").replace(/^public\//, "");
    if (!src.startsWith("/")) {
      src = "/" + src;
    }
  }
  var defaultResult = {
    src,
    width: 0,
    height: 0,
    blurDataURL: ""
  };
  if (!existsSync(resolvedPath)) {
    console.warn(`[one] getImageData: File not found: ${resolvedPath}`);
    return defaultResult;
  }
  var meta = await processImageMeta(resolvedPath);
  if (!meta) {
    return defaultResult;
  }
  return {
    src,
    ...meta
  };
}
export {
  getImageData,
  getSharp,
  processImageMeta
};
//# sourceMappingURL=getImageData.js.map
